<app-form-custmenubase
    [screenList]="screenList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-custmenubase>

